import React, { useEffect, useState } from "react";
import KMKSidenav from "../kmk/Sidenav";
import { getSidenavBottomItems, getSidenavItems } from "../layout/data";
import { useSelector } from "react-redux";
import UserJourney from "../UserJourney/UserJourney";

const Sidenav = (props) => {
  const [sidenavItems, setSidenavItems] = useState([]);
  const [sidenavBottomItems, setSidenavBottomItems] = useState([]);
  const [showIntro, setShowIntro] = useState(false);

  const permissions = useSelector((state) => state.permissions);

  useEffect(() => {
    if (Array.isArray(permissions)) {
      setSidenavItems(getSidenavItems(permissions));
      setSidenavBottomItems(getSidenavBottomItems(permissions));
    }
  }, [permissions]);

  return (
    <div>
      {showIntro && <UserJourney setShowIntro={setShowIntro} />}
      <KMKSidenav {...props} sidenavItems={sidenavItems} navBottomItems={sidenavBottomItems} />
    </div>
  );
};

export default Sidenav;
